import { css } from '@emotion/core';
import styled from '@emotion/styled';
import Colors from '@theme/colors';

const StatusIconStyle = () =>
  css`
    background-color: ${Colors.science37};
    border-radius: 50%;
    height: 8px;
    margin-left: 4px;
    margin-top: 4px;
    width: 8px;
  `;

const StatusIcon = styled.div`
  ${StatusIconStyle}
`;

export default StatusIcon;
